import {
    Analytics,
    safeWrap,
    getSelectedFilters,
    getCheckedFilters,
    getLocationFilter,
    getSelectedSortOption,
    getPositionOfBanner,
    PHONE_LINK_SELECTOR,
    ADD_TO_CART_SELECTOR,
} from '../../analytics/analytics';

const PAGE = 'searchRackPduPage';

const MIN_PRICE_SELECTOR =
    '.filter-list__item .range-slider__inputs input.js-range-slider__minCost';
const MAX_PRICE_SELECTOR =
    '.filter-list__item .range-slider__inputs input.js-range-slider__maxCost';

const { apcLogService } = window;
const preload = safeWrap('preload');
const setVariables = safeWrap('setVariables');
const setPageReady = safeWrap('setPageReady');
const getDefaultPageReadyPromise = safeWrap('getDefaultPageReadyPromise');

const getMaxPriceValue = () => {
    const maxPrice = document.querySelector(MAX_PRICE_SELECTOR);
    return maxPrice ? maxPrice.value.replace(',', '') : '';
};
const getMinPriceValue = () => {
    const minPrice = document.querySelector(MIN_PRICE_SELECTOR);
    return minPrice ? minPrice.value.replace(',', '') : '';
};

class RackPduAnalytics extends Analytics {
    constructor() {
        super();
        this.PAGE = PAGE;
    }

    init() {
        super.init();
        if (this.BLOCK) {
            this.BLOCK.addEventListener('price-filter-changed', e => this.priceFilter(e), true);
        }
    }

    handleEngagementClick = e => {
        super.handleEngagementClick(e);
        const { target } = e;
        let block = null;
        if (this.matchThisOrChildren(target, ADD_TO_CART_SELECTOR)) {
            block = this.getClosest(target, 'li.result-list__item_product');
            apcLogService(`${this.PAGE}.addToCart.click`, {
                target,
                productId: block.dataset.productId || '',
                url: document.location.href,
            });
        } else if (this.matchThisOrChildren(target, PHONE_LINK_SELECTOR)) {
            const metaPhoneNumber = document.querySelector('meta[name="tagging-site-phone"]');
            block = this.getClosest(target, 'li.result-list__item_product');
            apcLogService(`${this.PAGE}.phone.click`, {
                target,
                productId: block.dataset.productId || '',
                phoneNumber: metaPhoneNumber ? metaPhoneNumber.content : '',
                url: document.location.href,
            });
        }
    };

    priceFilter() {
        const filter = document.querySelector('.range-slider');
        apcLogService(`${this.PAGE}.priceFilter.click`, {
            target: filter,
            maxPrice: getMaxPriceValue(),
            minPrice: getMinPriceValue(),
        });
    }

    banner(target) {
        const block = this.getClosest(target, '.apc-banner');
        const { itemName = '' } = (block && block.dataset) || {};
        apcLogService(`${this.PAGE}.banner.click`, {
            target: block,
            name: itemName,
            position: getPositionOfBanner(target),
            url: block ? block.href : '',
        }); // banner
    }
}

try {
    preload(PAGE);
    setPageReady(
        getDefaultPageReadyPromise().then(() => {
            const modelFamily = getSelectedFilters('Product-Category');
            const inputVoltage = getCheckedFilters('Input-Voltage');
            const inputConnection = getCheckedFilters('Input-Connection-Type');
            setVariables({
                env_template: 'selector',
                page_name: 'rack-pdu-selector_step3-recommendations',
                page_cat1: 'rack-pdu-selector',
                page_level: '104',
                sales_insights: '1',
                selector_sort_option: getSelectedSortOption(),
                selector_country_filter: getLocationFilter(),
                selector_model_family: modelFamily,
                selector_input_voltage: inputVoltage,
                selector_input_connection: inputConnection,
                selector_min_price: getMinPriceValue(),
                selector_max_price: getMaxPriceValue(),
            });
            new RackPduAnalytics().init();
        }),
    );
} catch (err) {
    console.error(err);
}
